// Import puppy images
import { puppyImages } from '../assets/images'

// Puppy data with imported images for production compatibility
const puppies = [
    // 1. Cooper
    {
        id: 2,
        name: "COOPER",
        gender: "Male",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.zeus,
        description: " COOPER is very stunning and always draws the attention of passers-by, he loves outdoor walks and exercise, he is AKC registered and will come with complete papers, he gets along with other home pets and breeds and he comes from a great bloodlines, COOPER is already crate trained, potty trained and leash trained, looking for a show bully then COOPER is a perfect mate for that, i can guarantee you he will be a great stud someday, take him home now and thank me later.",
        sire: "Champion Brutus",
        dam: "Princess Luna",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Confident, Intelligent, Loyal"
    },
    // 2. Pinky
    {
        id: 7,
        name: "PINKY",
        gender: "Female",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.apollo,
        description: "Personality: Pinky is an outstanding smart guy, he gets along with other home pets and breeds and comes with complete papers, he is up to date on short, breeding rights will be provided as well, he is very friendly and always start the play, he will be a good fit in a family that has young kids as they will blend easily, he is a cuddle type and loves attention, he is looking for a new home, to spoil with love and fun, take him home now and thank me later",
        sire: "Red Warrior",
        dam: "Copper Flame",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Noble, Confident, Intelligent"
    },
    // 3. Lucy
    {
        id: 1,
        name: "LUCY",
        gender: "Female",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.athena,
        description: "Meet our stunning girl, LUCY! She loves to wake up early and take long morning walks in the fresh air. BETTY is very energetic and intelligent. She will make a great companion. BETTY will have a complete nose to tail vet check and arrive up to date on  her vaccinations. she is ready to meet his new family! Hurry! Don't let her pass you by! This playful guy can't wait to go on adventures with you. she is potty trained, crate trained, leash trained, AKC reg, and so much more! BETTY is the best of both worlds with her beauty and loving personality. Don't let her get away. she is a great girl looking for a great family like yours. Once he is with you, you'll wonder how you got along without her.",
        sire: "Baron Steel",
        dam: "Bella Rosa",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Gentle, Intelligent, Devoted"
    },
    // 4. Max
    {
        id: 10,
        name: "MAX",
        gender: "MALE",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.diana,
        description: "Personality: This is MAX! MAX has a beautiful and unique look; doesn't he? he also has an amazing personality to match. MAX loves everyone he meets and loves to shower you with all of his sweet puppy kisses. MAX will have a complete nose to tail vet check and arrive up to date on his vaccinations. You can't go wrong with this cutie. Don't miss out on him. our new puppy will take on a bit of your own personality in most cases and I can see this little boy being more of a follower than other puppies, he tends to want to do what the others are doing and blend in, I think this is one boy that will fall right in line with his new family. We have specialized in dachshund breed enhancement for 3 generations and you will see MAX comes with impressive pedigree, current on vaccines, microchipped, and pre-spoiled from our family, to yours.",
        sire: "Golden Thunder",
        dam: "Honey Moon",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Gentle, Intelligent, Loving"
    },
    // 5. Alpha
    {
        id: 4,
        name: "ALPHA",
        gender: "Male",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.luna,
        description: "Personality: ALPHA is very stunning and always draws the attention of passers-by, he loves outdoor walks and exercise, he is AKC registered and will come with complete papers, he gets along with other home pets and breeds and he comes from a great bloodlines, Stunner is already crate trained, potty trained and leash trained, looking for a show bully then Stunner is a perfect mate for that, i can guarantee you he will be a great stud someday, take him home now and thank me later.",
        sire: "Golden Caesar",
        dam: "Midnight Rose",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Gentle, Alert, Protective"
    },
    // 6. Rex
    {
        id: 18,
        name: "REX",
        gender: "Male",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.rex1,
        description: "Rex is a well-built puppy with a confident and alert appearance. He enjoys exploring new environments and staying active. Rex is AKC registered and will be provided with all necessary documents. He has a balanced temperament and coexists well with other pets. Rex comes from strong, carefully selected bloodlines. He is already familiar with crate routines, house training, and leash walking. Rex shows excellent potential for future training and development. He also has promising qualities for show or breeding purposes.",
        sire: "King Rex",
        dam: "Royal Guardian",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Confident, Alert, Balanced"
    },
    // 7. Channel
    {
        id: 20,
        name: "CHANNEL",
        gender: "Female",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.channel1,
        description: "Channel is an elegant and well-structured female puppy with a calm, confident aura. She enjoys gentle play and loves spending time around people. Channel is AKC registered and will be provided with all official paperwork. She has a friendly, well-mannered temperament and socializes well with other pets. Channel is bred from strong, carefully selected bloodlines. She is progressing well with crate habits, house training, and leash guidance. Channel would make a wonderful companion or future show prospect. She also carries excellent potential for responsible breeding.",
        sire: "Channel Master",
        dam: "Elegant Grace",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Elegant, Calm, Well-mannered"
    },
    // 8. Rosie
    {
        id: 21,
        name: "ROSIE",
        gender: "Female",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.rosie1,
        description: "Rosie is a lovely female puppy with a warm and charming personality. She enjoys interactive play and is always eager to learn. Rosie is AKC registered and will be sent home with complete documentation. She is affectionate, people-oriented, and comfortable around other pets. Rosie comes from carefully planned and reputable bloodlines. She is doing well with crate routines, house manners, and leash introduction. Rosie would make an excellent family companion or show-quality prospect. She also has promising potential for future breeding.",
        sire: "Rose King",
        dam: "Sweet Harmony",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Warm, Charming, Eager"
    },
    // 9. Thor
    {
        id: 16,
        name: "THOR",
        gender: "Male",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.thor1,
        description: "Personality: Thor is a striking puppy who naturally stands out wherever he goes. He enjoys outdoor activities and regular exercise. Thor is AKC registered and comes with complete paperwork. He has a friendly temperament and gets along well with other pets. He comes from excellent bloodlines. Thor is crate trained, potty trained, and leash trained. He has strong potential as a future show dog and stud.",
        sire: "Thunder King",
        dam: "Nordic Beauty",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Striking, Friendly, Confident"
    },
    // 10. Luna
    {
        id: 19,
        name: "LUNA",
        gender: "Female",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.luna1,
        description: "Luna is a beautiful female puppy with a gentle yet confident presence. She enjoys playtime and loves exploring her surroundings. Luna is AKC registered and will come with full documentation. She has a sweet, affectionate nature and bonds easily with people and pets. Luna is from carefully bred, high-quality bloodlines. She is already introduced to crate routines, house training, and leash guidance. Luna shows great promise as a family companion or show prospect. She also has excellent potential for future breeding.",
        sire: "Lunar Knight",
        dam: "Starlight Princess",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Gentle, Confident, Affectionate"
    },
    // 11. Bruno
    {
        id: 17,
        name: "BRUNO",
        gender: "Male",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.bruno1,
        description: "Bruno is a handsome puppy with a charming and playful personality. He enjoys daily walks and loves spending time outdoors. Bruno is AKC registered and comes with complete paperwork. He is friendly, social, and adapts well around other animals. Bruno is bred from solid and reputable bloodlines. He is well started with crate training, potty training, and leash manners. Bruno is an ideal choice for someone seeking a quality companion. He also has great potential for breeding in the future.",
        sire: "Champion Bruno",
        dam: "Bella Luna",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Charming, Playful, Social"
    },
    // 12. Betty
    {
        id: 5,
        name: "BETTY",
        gender: "Female",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.thor,
        description: "Personality: Dreaming of the perfect puppy? Then meet BETTY! She is sure to make all your dreams come true! she is a sweet and playful girl that can't wait to meet her new family. Once you see this cutie, it will be love at first sight. Just look at that precious face! Who could ever say no to her? Lighter will arrive up to date on vaccinations. Get ready for a mess of fun with this great girl at your side! I'm currently searching for a good, loving home. I hope to find a family that loves to play and loves to receive puppy kisses! I'm good at giving out plenty. Whether we're playing or cuddling together, I promise to be your most loving companion. I will arrive to my new home up to date on vaccinations and pre-spoiled. I cant wait to meet you. I have so much fun planned for us! See you soon!",
        sire: "Thunder Queen",
        dam: "Shadow Storm",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Confident, Protective, Gentle"
    },
    // 13. Daisy
    {
        id: 3,
        name: "DAISY",
        gender: "Female",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.maximus,
        description: "Personality: 'Playing is my favorite! I'm an active puppy that enjoys company. I can't wait to see my new home. To cheer up after a long day, puppy kisses do the trick! So don't worry, because I have plenty! I'm up to date on my vaccinations and vet checked from head to tail, so I'm a healthy pup. I will surely have your heart in no time! Besides, can't you see how attractive I am? Don't miss out on the fun! I can make your life just a bit more fun!' I'm currently searching for a good, loving home. I hope to find a family that loves to play and loves to receive puppy kisses! I'm good at giving out plenty. Whether we're playing or cuddling together, I promise to be your most loving companion. I will arrive to my new home up to date on vaccinations and pre-spoiled. I can't wait to meet you. I have so much fun planned for us! See you soon!",
        sire: "Titan Force",
        dam: "Stella Luna",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Bold, Playful, Stable"
    },
    // 14. Rocky
    {
        id: 8,
        name: "ROCKY",
        gender: "Male",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.venus,
        description: "Personality: Rocky is such a sweet girl and would love to be your best friend for life. Imagine all the fun you'll have with this cutie. You can take her for nice walks in the park or just cuddle with her. Pinky will have a complete nose to tail vet check and arrive with a current health certificate. This cutie has so much love to give and wants to share it with you. Don't miss out ! I'm currently searching for a good, loving home. I hope to find a family that loves to play and loves to receive puppy kisses! I'm good at giving out plenty. Whether we're playing or cuddling together, I promise to be your most loving companion. I will arrive to my new home up to date on vaccinations and pre-spoiled. I can't wait to meet you. I have so much fun planned for us! See you soon!",
        sire: "Blue Steel",
        dam: "Sapphire Dream",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Gentle, Intelligent, Sweet"
    },
    // 15. Hercules
    {
        id: 9,
        name: "HERCULES",
        gender: "Male",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.hercules,
        description: "Personality: Playing is my favorite! I'm an active puppy that enjoys company. I can't wait to see my new home. To cheer up after a long day, puppy kisses do the trick! So don't worry, because I have plenty! I'm up to date on my vaccinations and vet checked from head to tail, so I'm a healthy pup. I will surely have your heart in no time! Besides, can't you see how attractive I am? Don't miss out on the fun! I can make your life just a bit more fun! I'm currently searching for a good, loving home. I hope to find a family that loves to play and loves to receive puppy kisses! I'm good at giving out plenty. Whether we're playing or cuddling together, I promise to be your most loving companion. I will arrive to my new home up to date on vaccinations and pre-spoiled. I can't wait to meet you. I have so much fun planned for us! See you soon!",
        sire: "Midnight King",
        dam: "Dark Beauty",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Confident, Playful, Protective"
    },
    // 16. Coco
    {
        id: 22,
        name: "COCO",
        gender: "Female",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.coco1,
        description: "Coco is a beautiful female puppy with a bright and engaging personality. She loves playtime and enjoys being around people. Coco is AKC registered and will go home with full paperwork. She is friendly, well-socialized, and comfortable around other pets. Coco is from well-established and carefully selected bloodlines. She is learning crate routines, house manners, and leash basics. Coco would make a wonderful companion or potential show prospect. She also has strong potential for responsible breeding in the future.",
        sire: "Coco Champion",
        dam: "Chocolate Dream",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Bright, Engaging, Friendly"
    },
    // 17. Stunner
    {
        id: 6,
        name: "STUNNER",
        gender: "Male",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Available",
        image: puppyImages.bella,
        description: "Personality: Meet Stunner supper intelligent and energetic guy, he is very smart and active physically, he gets along with other home pets and breed, he is already crate trained and potty trained, his ability to understand commands is very high and he loves to do exercise that keeps him fit, he is AKC registered and will come with complete papers, if you are looking for the great stud take him and you will enjoy the best pups in the future.",
        sire: "Storm Cloud",
        dam: "Angel Wings",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Intelligent, Loyal, Calm"
    },
    // Sold puppies
    {
        id: 11,
        name: "DUKE",
        gender: "Male",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Sold",
        image: puppyImages.dan,
        description: "Personality: DUKE is very smart, he barks when necessary, he is potty trained and crate trained, he gets along with other home pets and breeds, he is current on shot and he will come with all his papers, another interesting thing about Luan is that he navigates the stair without any problem and understands the basic commands, looking at his physic he will make a perfect stud someday, he is AKC Registered and breeding right is provided. take him home now and make him part of your family.",
        sire: "Blue Diamond",
        dam: "Silver Moon",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Calm, Majestic, Gentle",
        soldDate: "2024-01-15",
        newFamily: "The Johnson Family"
    },
    {
        id: 12,
        name: "CLEOPATRA",
        gender: "Female",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Sold",
        image: puppyImages.cleopatra,
        description: "Cleopatra was a rare reverse brindle Cane Corso female with breathtaking beauty and exceptional bloodlines. Her unique coat pattern and queenly demeanor made her one of our most sought-after puppies. She now rules her new castle with grace.",
        sire: "Royal King",
        dam: "Egyptian Queen",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Regal, Intelligent, Dignified",
        soldDate: "2024-02-03",
        newFamily: "The Martinez Family"
    },
    {
        id: 13,
        name: "TITAN",
        gender: "Male",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Sold",
        image: puppyImages.titan,
        description: "Titan was a powerful black brindle Cane Corso male with incredible presence and perfect temperament. His impressive size and gentle nature with children made him the ideal family guardian. He's now protecting and loving his new family.",
        sire: "Atlas Strong",
        dam: "Warrior Princess",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Powerful, Gentle, Loyal",
        soldDate: "2024-01-28",
        newFamily: "The Wilson Family"
    },
    // Reserved puppies
    {
        id: 14,
        name: "CELIA",
        gender: "Female",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Reserved",
        image: puppyImages.celia,
        description: "Celia was a beautiful blue Cane Corso female with a calm, loving nature. She bonded quickly with her family and showed excellent trainability and gentle manners—an ideal companion and guardian.",
        sire: "Blue Knight",
        dam: "Moonlight Grace",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Gentle, Intelligent, Devoted",
        soldDate: "2024-03-12",
        newFamily: "The Carter Family"
    },
    {
        id: 15,
        name: "RHODES",
        gender: "Male",
        age: "10 weeks",
        registration: "AKC Registered",
        breed: "Cane Corso",
        price: "$700",
        status: "Reserved",
        image: puppyImages.rhodes,
        description: "Rhodes was a strong, confident Cane Corso male with a balanced temperament. His protective instincts and loving personality made him the perfect addition to his new household.",
        sire: "Iron Valor",
        dam: "Scarlet Dawn",
        vaccinations: "Up to date",
        health: "Health guarantee included",
        temperament: "Confident, Loyal, Calm",
        soldDate: "2024-03-25",
        newFamily: "The Bennett Family"
    }
];

export default puppies;
